<template>
	<div>
		<div class="menu">
			<div class="main-menu">
				<img class="logo" src="../../assets/img/logo.png" />
				<div class="right-box">
					<ul class="nav">
						<li>
							<a v-bind:class="{select:nowIndex==0}" @click='toIndex()'>首页</a>
						</li>
						<li>
							<a href="http://www.haopan.net/caiwu/" target="_blank">蜘蛛财务</a>
						</li>	
						<li>
							<a href="http://yun.haopan.net/" target="_blank">皓盘云</a>
						</li>
					</ul>
					<div class="loginBox">
						<a class="login" href="https://fee.haopan.net/#/login" target="_blank">登录</a>
						<a class="register" href="https://fee.haopan.net/#/register" target="_blank">注册</a>
					</div>
				</div>
			</div>
		</div>
		<!--head end-->
	</div>
</template>
<script>
	export default {
		data() {
			return {
				nowIndex: 0
			}
		},
		created() {

		},
		methods: {
			toIndex() {
				this.nowIndex=0;
				let path = "/";
				this.$router.push({
					path: path
				});
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/common/phead.vue